<section class="train-card-shell w-100">
  <div class="train-card-stage">
    <article
      class="train-card position-relative overflow-hidden {{ cardClass }}"
      [class.is-back]="
        card().cardType !== TrainCardType.ShortTalk && isBackVisible()
      "
      [class.is-correct]="
        card().cardType !== TrainCardType.ShortTalk &&
        isBackVisible() &&
        backIsCorrect === true
      "
      [class.is-incorrect]="
        card().cardType !== TrainCardType.ShortTalk &&
        isBackVisible() &&
        backIsCorrect === false
      "
      [class.is-multiple-choice]="
        card().cardType !== TrainCardType.ShortTalk && isChoiceCard()
      "
    >
      <header class="train-card-header {{ titleClass }}-header">
        <div class="train-card-header-row">
          <button
            type="button"
            class="train-card-close btn btn-system {{ closeClass }}"
            data-testid="training-back"
            [attr.aria-label]="t()['train.back']"
            [title]="t()['train.back']"
            [disabled]="isBusy()"
            (click)="close.emit()"
          >
            <svg class="sa-icon sa-icon-2x" aria-hidden="true">
              <use href="/assets/icons/sprite.svg#x"></use>
            </svg>
          </button>

          <h3
            class="train-card-title text-center fw-normal mb-0 {{ titleClass }}"
          >
            <span class="train-card-title-text">{{ deckTitle() }}</span>
            <span class="train-card-title-id">#{{ card().id }}</span>
          </h3>

          <app-theme-toggle
            class="train-card-theme-toggle"
            buttonClass="btn btn-system train-card-theme-toggle-btn"
          />
        </div>

        @if (showTrainingSessionProgress()) {
          <app-train-daily-goal-progress
            class="train-card-progress"
            [reviewedCards]="trainingSessionReviewedCards()"
            [dailyCardsTarget]="trainingSessionCardsTarget()"
            [ariaLabel]="trainingSessionProgressLabel()"
          />
        }
      </header>

      <div class="train-card-body">
        @if (isPracticeMode()) {
          <span
            class="train-card-practice-ribbon"
            role="status"
            [attr.aria-label]="t()['train.practiceNotice']"
            [title]="t()['train.practiceNotice']"
          >
            Practice
          </span>
        }

        @switch (card().cardType) {
          @case (TrainCardType.Text) {
            <app-text-train-front
              [card]="card()"
              [imageAsset]="imageAsset()"
              [canSpeakQuestion]="canSpeakQuestion()"
              [isQuestionAudioPlaying]="isQuestionAudioPlaying"
              (speak)="speak.emit()"
            />
          }
          @case (TrainCardType.Image) {
            <app-text-train-front
              [card]="card()"
              [imageAsset]="imageAsset()"
              [canSpeakQuestion]="canSpeakQuestion()"
              [isQuestionAudioPlaying]="isQuestionAudioPlaying"
              (speak)="speak.emit()"
            />
          }
          @case (TrainCardType.AudioRecord) {
            <app-audio-record-train-front
              [card]="card()"
              [imageAsset]="imageAsset()"
              [audioAsset]="audioAsset()"
              [isAudioPlaying]="isFrontAudioPlaying"
              (playAudio)="playAudio.emit()"
            />
          }
          @case (TrainCardType.AudioConversation) {
            <app-audio-conversation-train-front
              [class.audio-conversation-train-front--choice-back]="
                isChoiceCard()
              "
              [class.audio-conversation-train-front--choice-answer-visible]="
                isChoiceCard() && isBackVisible()
              "
              [card]="card()"
              [imageAsset]="imageAsset()"
              [audioAsset]="audioAsset()"
              [canSpeakQuestion]="canSpeakQuestion()"
              [isAudioPlaying]="isFrontAudioPlaying"
              [isQuestionAudioPlaying]="isQuestionAudioPlaying"
              (speak)="speak.emit()"
              (playAudio)="playAudio.emit()"
            />
          }
          @case (TrainCardType.VideoOnly) {
            <app-video-only-train-front
              [card]="card()"
              [videoAsset]="videoAsset()"
              [isTextSimpleBackVisible]="
                isBackVisible() &&
                card().cardSubType === TrainCardSubType.TextSimple
              "
              [canSpeakQuestion]="canSpeakQuestion()"
              [isQuestionAudioPlaying]="isQuestionAudioPlaying"
              (speak)="speak.emit()"
            />
          }
          @case (TrainCardType.ShortTalk) {
            <app-short-talk-train-front
              [card]="card()"
              [shortTalkSessionId]="shortTalkSessionId()"
              [openingReplyRequestId]="shortTalkOpeningReplyRequestId()"
              [canSpeakQuestion]="canSpeakQuestion()"
              [isQuestionAudioPlaying]="isQuestionAudioPlaying"
              (speakQuestion)="speak.emit()"
              (stopPlayback)="stopPlayback.emit()"
              (introStarted)="shortTalkIntroStarted.emit()"
              (messagesChange)="shortTalkMessagesChange.emit($event)"
            />
          }
          @case (TrainCardType.Pronunciation) {
            <app-pronunciation-train-front
              [card]="card()"
              [canSpeakQuestion]="canSpeakQuestion()"
              [isQuestionAudioPlaying]="isQuestionAudioPlaying"
              (speak)="speak.emit()"
              (assessmentComplete)="pronunciationAssessmentComplete.emit()"
            />
          }
        }

        @if (
          card().cardType !== TrainCardType.ShortTalk &&
          card().cardType !== TrainCardType.Pronunciation
        ) {
          @switch (card().cardSubType) {
            @case (TrainCardSubType.TextSimple) {
              <app-text-simple-train-back
                [card]="card()"
                [isBackVisible]="isBackVisible()"
                [hasFrontMedia]="!!imageAsset() || !!videoAsset()"
                [isVideoFront]="card().cardType === TrainCardType.VideoOnly"
              />
            }
            @case (TrainCardSubType.TextTypedOrVoice) {
              <app-text-typed-or-voice-train-back
                [card]="card()"
                [isBackVisible]="isBackVisible()"
                [isAudioFront]="
                  card().cardType === TrainCardType.AudioRecord ||
                  card().cardType === TrainCardType.AudioConversation
                "
                [hasFrontMedia]="!!imageAsset() || !!videoAsset()"
                [isVideoFront]="card().cardType === TrainCardType.VideoOnly"
                [isCorrect]="isTypedOrVoiceCorrect()"
                [userAnswer]="typedOrVoiceUserAnswer()"
                (continue)="continue.emit()"
                (userAnswerChange)="userAnswerChange.emit($event)"
              />
            }
            @case (TrainCardSubType.TextSingleChoice) {
              <app-text-multiple-choice-train-back
                [card]="card()"
                [isBackVisible]="isBackVisible()"
                [hasFrontMedia]="!!imageAsset() || !!videoAsset()"
                [isCorrect]="isMultipleChoiceCorrect()"
                [selectedOptionId]="multipleChoiceSelectedOptionId()"
                [selectedOptionIds]="multipleChoiceSelectedOptionIds()"
                [playableOptionIds]="multipleChoicePlayableOptionIds()"
                (selectedOptionIdChange)="selectedOptionIdChange.emit($event)"
                (selectedOptionIdsChange)="selectedOptionIdsChange.emit($event)"
                (optionSpeak)="optionSpeak.emit($event)"
              />
            }
            @case (TrainCardSubType.TextMultipleChoice) {
              <app-text-multiple-choice-train-back
                [card]="card()"
                [isBackVisible]="isBackVisible()"
                [hasFrontMedia]="!!imageAsset() || !!videoAsset()"
                [isCorrect]="isMultipleChoiceCorrect()"
                [selectedOptionId]="multipleChoiceSelectedOptionId()"
                [selectedOptionIds]="multipleChoiceSelectedOptionIds()"
                [playableOptionIds]="multipleChoicePlayableOptionIds()"
                (selectedOptionIdChange)="selectedOptionIdChange.emit($event)"
                (selectedOptionIdsChange)="selectedOptionIdsChange.emit($event)"
                (optionSpeak)="optionSpeak.emit($event)"
              />
            }
          }
        }
      </div>
    </article>
  </div>

  @if (shouldShowFeedback()) {
    <app-train-review-feedback
      class="mt-3"
      [class.train-review-feedback--centered-three]="
        shouldCenterFeedbackGrades()
      "
      [isBusy]="isBusy()"
      [selectedReviewGrade]="selectedReviewGrade()"
      [labels]="feedbackLabels"
      [hiddenGrades]="hiddenFeedbackGrades()"
      (review)="reviewGradeChange.emit($event)"
    />
  }

  @if (shouldShowContinue()) {
    <div class="d-flex justify-content-end mt-3">
      <button
        type="button"
        class="btn btn-outline-primary train-card-continue {{ continueClass }}"
        data-testid="training-continue"
        [disabled]="isBusy()"
        (click)="onContinue()"
      >
        {{ continueLabel }}
      </button>
    </div>
  }
</section>
